// extracted by mini-css-extract-plugin
export default {"circle":"SettingsIcon_circle__V94+c","green":"SettingsIcon_green__mKY94","line":"SettingsIcon_line__eiH3l"};